import colors from 'theme/_colors.scss';

export const GaugeColors = {
    Bad: colors.pomegranate,
    Tolerable: colors.orangePeel,
    Good: colors.jungleGreen,
    Unknown: colors.deionizerNull,
    Poor: colors.pomegranate
};

export const GaugeDefaults = {
    MIN: 0,
    MAX: 100,
    UNIT: '%',
    VALUE_PREFIX: '<'
};
